import axiosClient from "@/lib/axios/axiosClient";

export type LinkedRecordingSession = {
  id: string;
  deviceId: string;
};

export type LinkedRecordingSessionResponse = {
  message: string;
  data: LinkedRecordingSession;
};

export type LinkedRecordingSessionBody = {
  userId: number;
  deviceId: string;
};

export const addLinkedRecordingSession = async (
  body: LinkedRecordingSessionBody
): Promise<LinkedRecordingSessionResponse> => {
  const response = await axiosClient.post<LinkedRecordingSessionResponse>(
    "/linked-recording-sessions",
    body,
    {
      sendToken: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "text/plain; charset=utf-8",
      },
    }
  );
  return response.data;
};
